import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import PublicLayout from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";

export default function CheckoutCancel() {
  return (
    <PublicLayout>
      <section
        data-testid="checkout-cancel"
        className="mx-auto max-w-xl px-6 py-32 text-center"
      >
        <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full bg-secondary text-accent">
          <Leaf className="h-7 w-7" />
        </span>
        <h1 className="mt-6 font-serif text-4xl">No worries, no charge.</h1>
        <p className="mt-3 text-base text-muted-foreground">
          You cancelled the checkout. Nothing was charged. Come back to the
          shop when you&apos;re ready — the bench isn&apos;t going anywhere.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/shop">
            <Button variant="outline">Browse the shop</Button>
          </Link>
          <Link to="/">
            <Button className="bg-[#C9A961] text-[#3D3A33] hover:bg-[#DDBE7A]">
              Back home
            </Button>
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
